import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= breakpoint);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= breakpoint);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]);

  return isMobile;
}

function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const isMobile = useIsMobile();

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <header className="App-header">
      <nav className="nav-bar">
        <div className="logo-container">
          <img src="/images/logos/classic.PNG" alt="WormWagon Logo" className="nav-logo" />
          <div className="logo">WormWagon</div>
        </div>
        {/* Mobile hamburger menu button */}
        {isMobile && (
          <button 
            className={`mobile-menu-toggle ${mobileMenuOpen ? 'active' : ''}`}
            onClick={toggleMobileMenu}
            aria-label="Toggle mobile menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        )}
        {/* Only render one nav menu at a time */}
        {isMobile ? (
          <ul className={`nav-links mobile-nav ${mobileMenuOpen ? 'open' : ''}`}>
            <li><Link to="/" onClick={closeMobileMenu}>Home</Link></li>
            <li><Link to="/music" onClick={closeMobileMenu}>Music</Link></li>
            <li><Link to="/shows" onClick={closeMobileMenu}>Shows</Link></li>
            <li><Link to="/merch" onClick={closeMobileMenu}>Merch</Link></li>
            <li><Link to="/contact" onClick={closeMobileMenu}>Contact</Link></li>
          </ul>
        ) : (
          <ul className="nav-links desktop-nav">
            <li><Link to="/" onClick={closeMobileMenu}>Home</Link></li>
            <li><Link to="/music" onClick={closeMobileMenu}>Music</Link></li>
            <li><Link to="/shows" onClick={closeMobileMenu}>Shows</Link></li>
            <li><Link to="/merch" onClick={closeMobileMenu}>Merch</Link></li>
            <li><Link to="/contact" onClick={closeMobileMenu}>Contact</Link></li>
          </ul>
        )}
      </nav>
    </header>
  );
}

export default Navbar;